var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showConfig === 'true')?_c('div',[_c('ConfigView')],1):_c('div',[_c('Portlet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }